import { Link } from 'react-router-dom'
import { datetimeAgo } from '../../../helper'

export default function ReviewersGridItem({ reviewer }) {
  return (
    <Link
      to={`/reviewers/${reviewer.id}`}
      className="flex flex-col col-span-12 p-2 bg-white border-2 hover:border-accent-600 border-muted-600 md:col-span-6 lg:col-span-4 xl:col-span-3"
    >
      <div className="text-sm">
        <p>{datetimeAgo(reviewer.created_at)}</p>
        <p className="line-clamp-5">{reviewer.feedback}</p>
      </div>
    </Link>
  )
}
